import BodyText from 'LuxKit/Typography/BodyText'
import React from 'react'

function FlexibleCancellationCharterFlightFees() {
  return <BodyText variant="medium" as="span">
    <b>Date changes</b>
    <br />
    One change permitted up to 21 days prior to departure. Subject to availability and a change fee.
    <ul>
      <li>
        Economy: $200 change fee per person
      </li>
      <li>
        Business: $500 change fee per person
      </li>
    </ul>
    Additional change fees may apply for peak periods or property-specific surcharges.
    <br />
    <br />
    <b>Cancellations</b>
    <br />
    Cancellations made during this period will incur the following fees:
    <ul>
      <li>
        Economy: $995 per person
      </li>
      <li>
        Business: $2,995 per person
      </li>
    </ul>
    The remaining balance, after deduction of the applicable cancellation fees, will be refunded to your original payment or credit.
  </BodyText>
}

export default FlexibleCancellationCharterFlightFees
